import React, { Fragment, useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import { useSelector } from "react-redux";

import { useAxios, useComponent } from "../../hooks";

import { Paper } from "../../components";
import Table from "./logs list components/Table";
import GenerateReportDialog from "./logs report dialog/GenerateReportDialog";

export default function LogsReportList({ pageID }) {
  const axios = useAxios();
  const { loader } = useComponent({ pageID });
  const { ID, activeBot } = useSelector((state) => state.memberDetails);

  const [members, setMembers] = useState([]);
  const [logsReport, setLogsReport] = useState([]);
  const [generateReportDialog, setGenerateReportDialog] = useState(false);

  const generateList = () => {
    axios({
      url: `/insights/log-list/${ID}`,
      method: "GET",
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        if (Array.isArray(response.data)) {
          setLogsReport(response.data);
        }
      }
      loader.apiComplete();
    });
  };

  useEffect(() => {
    loader.start();
    generateList();

    axios({
      url: `/member/list?bot_id=${activeBot.ID}`,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setMembers(response.data);
      }
      loader.apiComplete();
    });

    loader.apiComplete();
  }, [axios, ID]);

  return (
    <Fragment>
      <Paper>
        <Grid item xs={12} display={"flex"} justifyContent={"end"}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setGenerateReportDialog(true)}
          >
            Generate Logs Report
          </Button>
        </Grid>
      </Paper>

      <Table logsReport={logsReport} setLogsReport={setLogsReport} />

      {generateReportDialog && (
        <GenerateReportDialog
          generateReportDialog={generateReportDialog}
          setGenerateReportDialog={setGenerateReportDialog}
          members={members}
          loader={loader}
          generateList={generateList}
        />
      )}
    </Fragment>
  );
}
